import { makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => ({
  wrap: {
    // width: 311,
  },
  textFieldWrap: {
    width: 230,
    // height: 32,
  },
}));

export default useStyles;
